module.exports = __webpack_public_path__ + "static/media/benefits-parents.530da4a8.jpg";